import MegaMenu from './MegaMenu';

export { type MegaMenuProps } from './MegaMenu';
export default MegaMenu;
